'use es6';

export default ['basic', 'apiFast', 'apiFull'];